import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { IMG } from '../../data/homeData';
import '../../styles/reference/master_signup.scoped.css'; // real signup CSS, scoped to .reddy-signup
import '../../styles/signup-base.css';

const IndiaFlag = () => (
  <svg className="iti__flag-img" viewBox="0 0 30 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect width="30" height="20" fill="#fff" />
    <rect width="30" height="6.67" fill="#FF9933" />
    <rect y="13.33" width="30" height="6.67" fill="#138808" />
    <circle cx="15" cy="10" r="2.4" fill="none" stroke="#000080" strokeWidth="0.6" />
  </svg>
);

export default function SignupModal({ open, onClose, onLogin }) {
  const [otpSent, setOtpSent] = useState(false);
  const [timer, setTimer] = useState(0);
  const [logoFailed, setLogoFailed] = useState(false);
  const timerRef = useRef(null);

  const startTimer = () => {
    setTimer(30);
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setTimer((t) => { if (t <= 1) { clearInterval(timerRef.current); return 0; } return t - 1; });
    }, 1000);
  };
  const sendOtp = () => { setOtpSent(true); startTimer(); };

  useEffect(() => {
    if (!open) { setOtpSent(false); setTimer(0); clearInterval(timerRef.current); }
  }, [open]);
  useEffect(() => () => clearInterval(timerRef.current), []);
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;
  const stop = (e) => e.preventDefault();

  return ReactDOM.createPortal(
    <div className="reddy-signup">
      <div className="signup-backdrop" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
        <div className="signUpUi">
          <button type="button" className="signup-close" aria-label="Close" onClick={onClose}>×</button>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 text-center px-0">
                {logoFailed
                  ? <span className="main-logo-text">REDDY <b>ANNA BOOK</b></span>
                  : <img className="main-logo" width="150" alt="Reddy Anna Book" src={`${IMG}/reddybook-logo.png`} onError={() => setLogoFailed(true)} />}
                <h4 className="head-title">Register</h4>
              </div>
            </div>
            <form id="signup_form" onSubmit={stop}>
              <div className="form-group">
                <label>Username</label>
                <input type="text" className="form-control" placeholder="Username 4 To 15 Alphanumeric" />
              </div>
              <div className="form-group">
                <label>Mobile</label>
                <div className="iti iti--separate-dial-code">
                  <div className="iti__flag-container">
                    <div className="iti__selected-flag" title="India (+91)">
                      <IndiaFlag />
                      <span className="iti__selected-dial-code">+91</span>
                      <span className="iti__arrow" />
                    </div>
                  </div>
                  <input type="number" className="form-control" placeholder="Mobile No" />
                </div>
              </div>
              <div className="form-group">
                <label>Password</label>
                <input type="password" className="form-control" placeholder="Password 6 To 20 Alphanumeric" />
                <small style={{ color: 'red' }}>(Must be contained alphanumeric and more than 6 letters)</small>
              </div>
              <div className="form-group">
                <label>Referral Code</label>
                <input type="text" className="form-control" placeholder="Referral Code (Optional)" />
              </div>
              <div className="col-12 px-0">
                <small>By continuing you will receive a one-time verification code to your phone number by SMS.</small>
              </div>
              {!otpSent ? (
                <button type="button" className="btn btn-primary" id="send_otp" onClick={sendOtp}>Get OTP On Whatsapp</button>
              ) : (
                <>
                  <div className="form-group" id="otp_group">
                    <label>OTP</label>
                    <input type="text" id="otp" className="form-control" placeholder="OTP" />
                    <button type="button" id="resend_otp" className="btn" disabled={timer > 0} onClick={startTimer}>Resend OTP</button>
                    {timer > 0 && <div id="timer-div">Resend OTP in : <span id="timer">{timer}s</span></div>}
                  </div>
                  <button type="button" className="btn btn-primary" id="signup_submit">Signup</button>
                </>
              )}
            </form>
            <div className="signUpNew_info">
              <span>Already have account?</span> <a href="/login" onClick={(e) => { e.preventDefault(); if (onLogin) onLogin(); }}>Log In</a>
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
}
